import React, { Component } from "react";
import { DataTableToolbar } from "../../components/ui";
import AppBadge from "../../components/ui/AppBadge";
import { StatusChangeItem } from "../../models/BoricaTransaction";
import { toastService } from "../../services/toastService";
import { boricaTransactionApiService } from "../../services/api/transactions/BoricaTransactionApiService";
import { utils } from "../../utils/utils";
import { SearchRequestBaseModel, SortOrderType } from "../../models/SearchRequestModel";
import ExtendedDataTable from "../../components/ExtendedDataTable";
import { Column } from "primereact/column";

interface StatusChangelogState {
    changes: StatusChangeItem[];
    isLoading: boolean;
    totalRecords: number;
}

export default class StatusChangelog extends Component<Record<string, never>, StatusChangelogState> {
    private dataTable: ExtendedDataTable | null = null;

    constructor(props: Record<string, never>) {
        super(props);
        this.state = {
            changes: [],
            isLoading: false,
            totalRecords: 0,
        };
    }

    loadData = async (searchRequest: SearchRequestBaseModel) => {
        this.setState({ isLoading: true });
        searchRequest.filters = utils.manageDataTableFilters(searchRequest.filters);
        const result = await boricaTransactionApiService.searchStatusChanges(searchRequest);
        if (!result.success) {
            toastService.error(result.message);
        }
        this.setState({
            changes: result.data ?? [],
            totalRecords: result.totalCount,
            isLoading: false,
        });
    };

    renderHeader = (hasActiveFilters: boolean) => (
        <DataTableToolbar
            onClear={() => this.dataTable!.reset()}
            hasActiveFilters={hasActiveFilters}
        />
    );

    dateBodyTemplate = (rowData: StatusChangeItem) => {
        try {
            return utils.formatDateTimeSofia(rowData.changedAt);
        } catch {
            return rowData.changedAt || "-";
        }
    };

    parentChangedBodyTemplate = (rowData: StatusChangeItem) => {
        if (rowData.parentTransactionStatusChanged) {
            return <AppBadge variant="success">Yes</AppBadge>;
        }
        return <AppBadge variant="neutral">No</AppBadge>;
    };

    render() {
        return (
            <ExtendedDataTable
                header={this.renderHeader}
                ref={(ref) => (this.dataTable = ref)}
                value={this.state.changes}
                onChange={this.loadData}
                loading={this.state.isLoading}
                totalRecords={this.state.totalRecords}
                defaultSortField="changedAt"
                defaultSortOrder={SortOrderType.Descending}
            >
                <Column {...({ alwaysVisible: true } as any)} field="boricaPayDutyRequestId" header="Pay Duty ID" />
                <Column {...({ alwaysVisible: true } as any)} field="boricaTransactionId" header="Transaction ID" />
                <Column {...({ alwaysVisible: true } as any)} field="oldStatus" header="Old Status" />
                <Column field="newStatus" header="New Status" />
                <Column
                    field="parentTransactionStatusChanged"
                    header="Payment Updated"
                    body={this.parentChangedBodyTemplate}
                />
                <Column field="changedByUserName" header="Changed By" />
                <Column field="changedByUserId" header="User ID" />
                <Column
                    field="changedAt"
                    header="Changed At"
                    body={this.dateBodyTemplate}
                />
            </ExtendedDataTable>
        );
    }
}
